import gekkoRoutes from "./gekko"

export default [
  ...gekkoRoutes
]